export default {
  HOME_DRAWER: 'Home',
  SEARCH_DRAWER: 'Search',
  FAVORITE_DRAWER: 'Favorites',
  PRESENTATION_DRAWER: 'Presentations',
  DOWNLOAD_DRAWER: 'Downloads',
};
